<template>
  <component :is="tag" :href="url" :title="title" target="_blank" style="text-decoration: none">
    <slot>
      <site-icon :social-site="socialSite" />
    </slot>
    <q-tooltip v-if="tag === 'a'">{{ title }}</q-tooltip>
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SiteIcon from '@/social/site/SiteIcon.vue';
import { SocialSite } from '@/type';

export default defineComponent({
  components: { SiteIcon },
  props: {
    url: {
      type: String,
      required: true,
    },
    socialSite: {
      type: Object as () => SocialSite,
      required: true,
    },
  },
  computed: {
    hasUrl(): boolean {
      return new RegExp('^https?://').test(this.url);
    },
    tag(): string {
      return this.hasUrl ? 'a' : 'span';
    },
    title(): string {
      return `View on ${this.socialSite.name}`;
    },
  },
});
</script>
